import { useEffect, useState } from 'react'

import NotesWithDrawer from './NotesWithDrawer'
import { useCreateNote } from '../hooks/useCreateNote'
import { getNotesQueryKey, useGetNotes } from '../hooks/useGetNotes'

interface EmployerNotesWithDrawerProps {
  displayExistingNotes?: boolean
  employerId: string
  subjectId?: string
  subjectType?: string
}

const EmployerNotesWithDrawer = ({
  displayExistingNotes = true,
  employerId,
  subjectId,
  subjectType,
}: EmployerNotesWithDrawerProps) => {
  const {
    data: notes,
    error,
    isLoading,
  } = useGetNotes({ employerId, displayExistingNotes })
  const createNoteMutation = useCreateNote({ employerId, subjectType, subjectId })
  const notesQueryKey = getNotesQueryKey({ employerId })

  // Both of these may only become true (they don't get set back to false)
  const [isInitialLoadComplete, setIsInitialLoadComplete] = useState(false)
  const [isUnauthorized, setIsUnauthorized] = useState(false)

  useEffect(() => {
    const receivedData = Boolean(notes || error)
    if (receivedData) {
      setIsInitialLoadComplete(true)
    }
  }, [error, notes, setIsInitialLoadComplete])

  useEffect(() => {
    if (error?.status === 401) {
      setIsUnauthorized(true)
    }
  }, [error, setIsUnauthorized])

  return (
    <NotesWithDrawer
      error={error}
      isLoading={isLoading}
      createNoteMutation={createNoteMutation}
      displayExistingNotes={displayExistingNotes}
      notes={notes || []}
      queryKey={notesQueryKey}
      isInitialLoadComplete={isInitialLoadComplete}
      isUnauthorized={isUnauthorized}
    />
  )
}

export default EmployerNotesWithDrawer
